var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDockLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1d0e3d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.672,0H1.328A1.279,1.279,0,0,0,.391.391,1.279,1.279,0,0,0,0,1.328v9.344a1.279,1.279,0,0,0,.391.938A1.279,1.279,0,0,0,1.328,12h9.344A1.334,1.334,0,0,0,12,10.672V1.328a1.279,1.279,0,0,0-.391-.938A1.279,1.279,0,0,0,10.672,0ZM1.328,1.328h2v9.344h-2Zm3.344,9.344V1.328h6v9.344Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockLeft);
export default __webpack_public_path__ + "static/media/dock-left.441a465ef757a69f9c5914badf0cb8d4.svg";
export { ForwardRef as ReactComponent };